import type { PickemDto } from '@/api/backoffice-schemas';
import type { SupportedGame } from '@/config/supportedGames';
import { PickedPickemsList } from './PickedPickemsList';
import { PickemBetTabsCommon } from './PickemBetTabsCommon';
import PickemsBetHistory from './PickemsBetHistory';

interface PickemBetsTabsProps {
  selectedPickems: PickemDto[];
  totalPickems: number;
  game: SupportedGame;
  onClearAll: () => void;
  onRemove: (pickemId: string) => void;
  onSuccess: () => void;
}

export const PickemBetsTabs = ({
  selectedPickems,
  totalPickems,
  game,
  onClearAll,
  onRemove,
  onSuccess,
}: PickemBetsTabsProps) => {
  return (
    <PickemBetTabsCommon
      history={<PickemsBetHistory game={game} />}
      list={
        <PickedPickemsList
          onClearAll={onClearAll}
          onRemove={onRemove}
          onSuccess={onSuccess}
          selectedPickems={selectedPickems}
          totalPickems={totalPickems}
        />
      }
    />
  );
};
